define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/xml",
	"csi/xml/Query",
	"file-saver"
], function(declare, lang, csi, Controller, PostRequest, xml, Query, FileSaver) {
	return declare(Controller, {
		process: function() {
			// summary: add the query and query limit path to the call
			const store = this.widget.get("store");
			const query = this.widget.getQueryResultQuery();
			const storeRequest = store.getRequest(query, null, true);

			this.query = storeRequest.binaryQuery;
			this.queryLimitPath = storeRequest.getParameter("Qry.Limit.Path");

			const {m_module, m_operation} = this.m_action.m_request;
			const request = new PostRequest(m_module, m_operation);
			request.addParameter("Query", storeRequest.binaryValue);
			request.addParameter("QueryLimitPath", this.queryLimitPath);
			request.addParameter("ReturnNodes", "None");

			this.waitForPublish(request.post(), true);
		},

		postProcessSuccess: function() {
			// come up with URL's returned by above operation
			const urls = this.m_response.getResultUrls().join(";") || csi.EMPTY_URL;

			// export quotes
			var request = new PostRequest("Export", "OnDemandExport", {
				"ExportType": "Excel",
				"View": this.widget.get("customViewId"),
				"Query": new Query().Node(xml.PROP_TYPE, xml.OP_EQUALS, "SupplierItem"),
				"QueryLimitPath": urls,
				"OutputJSON": "0"
			});

			const callServerHttpPost = request.post({ handleAs: "blob" });

			//Save downloaded file
			callServerHttpPost.then((response) => {
				const fileName = this.getRequestActionId() + ".xls"; // Currently server sends xls file only
				FileSaver.saveAs(response.data, fileName); 
			});			
		}
	});
});
